import { h, Host } from "@stencil/core";
import { autoExtract } from "../utils/autoExtract";
/** Render a single row data as a grid of information. */
export class TableDetail {
  constructor() {
    this.renderCell = (name) => {
      const cell = this.getCell(name);
      if (this.loading) {
        if (cell.expectedLength === 0 && !cell.variance)
          return undefined;
        if (cell.expectedLength === undefined && !cell.title?.length)
          return undefined;
        return (h("es-loading-text", { expectedLength: Math.max(cell.title?.length ?? 0, cell.expectedLength ?? 30), variance: cell.variance }));
      }
      else if (cell.cell) {
        return cell.cell(h, {
          data: this.data,
          key: name,
          parent: this.identifier,
        });
      }
      else {
        return autoExtract(this.data, name);
      }
    };
    this.getCell = (col) => {
      return this.cells[col] ?? { title: '' };
    };
    this.identifier = 'detail';
    this.data = undefined;
    this.cells = undefined;
    this.columns = undefined;
    this.loading = undefined;
  }
  render() {
    const columns = this.columns ||
      Object.keys(this.cells).filter((name) => name !== 'actions');
    return (h(Host, null, h("dl", { class: { loading: !!this.loading } }, columns.map((name) => {
      const { title, variant, align = 'start', } = this.getCell(name);
      const variants = typeof variant === 'string'
        ? [variant]
        : variant ?? [];
      return (h("div", { class: {
          cell: true,
          full_width: variants.includes('full-width'),
          [align]: align !== 'start',
        } }, h("dt", null, title), h("dd", null, this.renderCell(name))));
    }))));
  }
  static get is() { return "es-table-detail"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-table-detail.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-table-detail.css"]
    };
  }
  static get properties() {
    return {
      "identifier": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Passed to cell renderer as `parent`."
        },
        "attribute": "identifier",
        "reflect": false,
        "defaultValue": "'detail'"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The data to render."
        },
        "attribute": "data",
        "reflect": false
      },
      "cells": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TableCells<any, any>",
          "resolved": "{ [x: string]: TableCell<any, any>; }",
          "references": {
            "TableCells": {
              "location": "import",
              "path": "../types",
              "id": "src/components/tables/types.ts::TableCells"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "A record of table cell definitions."
        }
      },
      "columns": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Array<string>",
          "resolved": "string[] | undefined",
          "references": {
            "Array": {
              "location": "global",
              "id": "global::Array"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "The order and keys of the cells to be rendered. If omitted, all cells will be rendered."
        }
      },
      "loading": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean | undefined",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Indicates if the loading indicators should be displayed"
        },
        "attribute": "loading",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=es-table-detail.js.map
